/*
 * @Author: your name
 * @Date: 2020-07-30 15:32:11
 * @LastEditTime: 2020-08-03 16:55:27
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/vender/form-schema-config/components/form-value-select.config.js
 */
const FormValueSelectConfig = {
  // 类型
  componentType: 'FORM_SELECT_INPUT',
  // 部件显示样式
  widgetConfig: {
    icon: 'x-lib-select',
    text: '下拉框',
    optionTitle: true,
    description: '用于预设选项过多，通过下拉菜单展示并选择'
  },
  componentConfig: {
    uuid: `32bit uuid`,
    width: 6, // 3, 6, 9, 12
    height: 1,
    render: {
      ide: 'FormValueSelect',
      edit: 'FormValueSelect',
      read: 'FormValueSelect'
    },
    label: '下拉框',
    multicolor: true,
    placeholder: '请选择',
    readOnly: false,
    defaultValue: null,
    selectDefaultValue: [],
    chooseType: 'SINGLE',
    customDefaultKey: 'selectDefaultValue',
    chooseOptions: [
      {
        checked: false,
        color: '#027aff',
        id: randomCode(),
        label: '选项1',
        status: 'ENABLE'
      },
      {
        checked: false,
        color: '#027aff',
        id: randomCode(),
        label: '选项2',
        status: 'ENABLE'
      },
      {
        checked: false,
        color: '#027aff',
        id: randomCode(),
        label: '选项3',
        status: 'ENABLE'
      }
    ],
    inTable: true,
    methods: {
      lcInitData: {
        edit: (...args) => {
          console.log(args)
        }
      },
      lcConvertDefaultValue: (config) => {
        return config.selectDefaultValue
      }
    }
  },
  methods: {},
  editorConfig: [
    'INFO',
    'LABEL',
    'PLACEHOLDER',
    'CHOOSETYPE',
    'MULTICOLOR',
    'WIDTH',
    'HIDDEN',
    'READONLY',
    'REQUIRED',
    'EDITONNEW',
    'UNIQUE'
  ],
  excludeEditorConfigInTable: ['WIDTH']
}
function randomCode() {
  const codes = 'ABCDEFGHIJKLMNOPQRSTUVEXYZabcdefghijklmnopqrstuvwxyz1234567890'
  let randomCode = ''
  for (let i = 0; i < 5; i++) {
    let index = parseInt(Math.random() * (codes.length - 0 + 1) + 0, 10)
    randomCode += codes.charAt(index)
  }
  return randomCode
}
export default FormValueSelectConfig
